import { t } from 'i18next';

import { OperationMode } from '../../../../../PcfWizard.type';

export const getPlaceholder = (operationMode: string): string => {
  switch (operationMode) {
    case OperationMode.HANDLING_TIME:
      return t(
        'footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.inputs.placeholders.handlingTime',
      );
    case OperationMode.RUNS_PER_CYCLE:
      return t(
        'footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.inputs.placeholders.runsPerCycle',
      );
    default:
      return '';
  }
};

export const getButtonLabel = (operationMode: string): string => {
  switch (operationMode) {
    case OperationMode.HANDLING_TIME:
      return t(
        'footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.inputs.placeholders.handlingTimeSelectButtonLabel',
      );
    case OperationMode.RUNS_PER_CYCLE:
      return t(
        'footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.inputs.placeholders.runsPerCycle',
      );
    default:
      return '';
  }
};
